
import { toast } from 'react-toastify';
import { browserHistory } from 'react-router';

const CORRECT_LOGIN_PASS = "CORRECT_LOGIN_PASS";
const FIRST_LOGIN = "FIRST_LOGIN";
const CAPTCHA_ERROR = "CAPTCHA_ERROR";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_ERROR = "LOGIN_ERROR";
const SAVE_TOKEN = "SAVE_TOKEN";
const TOKEN_ERROR = "TOKEN_ERROR";
const SET_USER_DATA = "SET_USER_DATA";
const SET_CAPTCHA_DATA = "SET_CAPTCHA_DATA";
const FIRST_ACCESS = "FIRST_ACCESS";


function setCorrectLoginPass(isCorrectLoginPass) {
  return {
    type: CORRECT_LOGIN_PASS,
    isCorrectLoginPass
  }
}

function setFirstLogin(isFirstLogin) {
  return {
    type: FIRST_LOGIN,
    isFirstLogin
  }
}

function setCaptchaError(isCaptchaError) {
  return {
    type: CAPTCHA_ERROR,
    isCaptchaError
  }
}

function setLoginSuccess(isLoginSuccess) {
  return {
    type: LOGIN_SUCCESS,
    isLoginSuccess
  };
}

function setFirstAccess(isFirstAccess) {
  return {
    type: FIRST_ACCESS,
    isFirstAccess
  };
}

function setLoginError(isLoginError) {
  return {
    type: LOGIN_ERROR,
    isLoginError
  };
}

function setTokenError(tokenError) {
  return {
    type: TOKEN_ERROR,
    tokenError
  };
}

function setToken(token) {
  return {
    type: SAVE_TOKEN,
    token
  };
}

function setUserData(user) {
  return {
    type: SET_USER_DATA,
    user
  };
}

function setCaptchaData(captcha) {
  return {
    type: SET_CAPTCHA_DATA,
    captcha
  }
}


export function getToken() {
  return dispatch => {
    const URL = `${process.env.REACT_APP_API_URL}/api/token`;
    const HEADER = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*"
    });
    let dados = `username=${process.env.REACT_APP_API_USER}&password=${process.env.REACT_APP_API_PASS}&grant_type=password`;

    fetch(URL, { method: "POST", headers: HEADER, body: dados })
      .then(response => response.json())
      .then(result => {
        dispatch(setToken(result.access_token));
      })
      .catch(err => {
        if (err) dispatch(setTokenError(err));
      });
  };
}

export async function smsToken(fone, token) {
  let dados = `username=${process.env.REACT_APP_API_USER}&password=${process.env.REACT_APP_API_PASS}&grant_type=password`;
  const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/sms/${fone}`;
  await fetch(URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": "Bearer " + token
    },
    body: JSON.stringify({ body: dados.JSON })
  });
}

export async function smsConfirm(fone, inputToken, token) {
  let dados = `username=${process.env.REACT_APP_API_USER}&password=${process.env.REACT_APP_API_PASS}&grant_type=password`;
  const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/sms/${fone}/${inputToken}`;
  const response = await fetch(URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": "Bearer " + token,
    },
    body: JSON.stringify({
      body: dados.JSON,
    }),
  });
  const data = await response.json();
  return data;
}


export function checkCaptcha() {
  return dispatch => {
    dispatch(setCaptchaError(true));
  }
}

export function doLogout() {
  return dispatch => {

    dispatch(setFirstAccess(false));
    dispatch(setLoginSuccess(false));
  }
}

export function stayLogged(user) {
  return dispatch => {
    dispatch(setUserData(JSON.parse(user)));
    dispatch(setLoginSuccess(true));
    dispatch(setLoginError(null));
  }
}




export function doLogin(cpf, token, stayLogged, senhaDigitada, firstAccessCheck, canLogin, captchaNotAproved) {
  // console.log(`can login - do login: ${canLogin}`)
  return dispatch => {
    const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/clientZema/${cpf}`;
    const HEADER = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": "Bearer " + token
    });

    fetch(URL, { method: "GET", headers: HEADER })
      .then(response => response.json())
      .then(usuario => {
        if (usuario.type) {
          if (usuario.type === "error") {
            //dispatch(setLoginError(usuario.message));
            toast.error("CPF não encontrado ou não é cliente Zema!");
            return;
          }
          else if (canLogin === false) {
            toast.error("Login não aprovado pelo ReCaptcha!");
          }
        }
        else if (canLogin === false) {
          toast.error("Login não aprovado pelo ReCaptcha!");
        }


        // console.log("senhaDigitada - Actions : " + senhaDigitada)
        // console.log("Senha API - Actions : " + usuario.SENHA)

        // console.log("//Stay Logged= " + usuario.SENHA);
        localStorage.setItem("boleto@dataUser", JSON.stringify(usuario));

        dispatch(setUserData(usuario));
        // console.log( JSON.stringify(usuario))
        //dispatch(setLoginSuccess(true));
        dispatch(setLoginError(null));

        if (stayLogged) {


          if (!firstAccessCheck) {
            if (canLogin === true) {

              if (usuario.SENHA === senhaDigitada) {
                // console.log("Senha Correta");

                browserHistory.push("/venda")
                dispatch(setFirstLogin(false));
                dispatch(setCorrectLoginPass(true));

              }

              else if (usuario.SENHA !== senhaDigitada) {
                toast.error("Senha incorreta ou não cadastrada!");
                dispatch(setCorrectLoginPass(false));
              }
            }
          }
        }

        if (firstAccessCheck) {
          if (usuario.SENHA === undefined || usuario.SENHA === null) {//PRIMEIRO ACESSO
            // console.log("//PRIMEIRO ACESSO -  usuario.SENHA = " + usuario.SENHA);
            browserHistory.push("/")
            dispatch(setFirstAccess(true));
            dispatch(setLoginSuccess(true));
          } else {
            toast.error("CPF já cadastrado ou não liberado para cadastro!");
            dispatch(setFirstAccess(false));
            dispatch(setLoginSuccess(true));
          }
        }


      })
      .catch(err => {
        if (err) dispatch(setLoginError(err.message));
        dispatch(setLoginSuccess(false));
      });
  };
}

export function doCaptcha(recaptchaToken, token) {

  //var tokenSwagger = "KJojjnjkdYXhYqO59CWuleunOUysSi1Wmz9A9L9FEMs9a593uBgG23SzegKuriPThfyIBqVIDCFsflt5lGv6l51ymItw-3rY2X-mobUw6C7Bq-SZQQFMAWc-zAEfItqc-D_pNO-vKdt1KK14wThVGOHzzf7uWRN3FByodxbrGE93l55OejdNgf5MAE9TGu4EJEHBOb57_-9PMmCqkuQSA6hFbDcCxIwE8xByzX_u6H4"

  return dispatch => {

    //let captchaPrivateKey = "6LeQHZQUAAAAAL8RbS61Iy6q_PQ39x8TxGgMaW3N";
    //let response = "03AOLTBLSBXCmrkqecRTwbyU30NcJjTxwh8ROEu5duP-Fzc4cSQp0J3T6hV5Pxu1xvNFi2dOT_u2B8l7EktEAEKsV2uSsGTAoDB4amdZMvI2mlMPnjlD5W34PtPObl0EFU-wVjBE8yM3pjrLrlZrSEXOyzd6HKm7NAPDBUi585o0qQNzWoyuokv5VM3aZ3Xc3tzzfYUprTUMzao0ExytbBrTXHiPHMpLx047Lw9Pov6SQljLFoUmJb1jPCuRS9-6txstqh0FzAp327ZMS5AzDR04rslSJA2HmtPp5kiOxn-TmmwgW9A8Bxs5mfFJfyOM3Isvu2arqlxJn6"
    //console.log("response Captcha" + recaptchaToken)
    // // console.log("cpf:" + cpf + " token: " + token)
    const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/recaptcha?response=${recaptchaToken}`
    // console.log(`recaptchaToken doCaptcha: ${recaptchaToken}`)
    if (recaptchaToken !== '') {
      dispatch(setCaptchaError(false))
    }
    if (recaptchaToken === '') {
      console.log(`recaptchaToken doCaptcho nulo`)
      dispatch(setCaptchaError(true))
    }
    //console.log("url api ReCaptcha: " + URL)
    const HEADER = new Headers({
      "Content_Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": "Bearer " + token

      // chumbar token
    })
    fetch(URL, { method: "GET", headers: HEADER })
      .then(response => response.json())
      .then(captcha => {
        dispatch(setCaptchaData(JSON.stringify(captcha)));
      })
      .catch(err => {
        //console.log(`err captcha: ${err}`)
      })
  }
}


export function sendMail(cpf, token) {
  return dispatch => {
    // console.log("SendMail: " + cpf)
    if (cpf !== undefined || cpf !== null) {
      // // console.log("cpf:" + cpf + " token: " + token)
      const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/emailzema/${cpf}`;
      const HEADER = new Headers({
        "Content_Type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Authorization": "Bearer " + token
      })
      fetch(URL, { method: "GET", headers: HEADER })
        .then(response => response.json()
          .then(toast.success(`E-mail enviado com sucesso`))
        )
        .catch(err => {
          // console.log(err)
          toast.error(`Erro ao enviar e-mail`)
        })
    }
    else {
      toast.error(`Erro ao enviar e-mail`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/Actions/login.js